<template>
  <NuxtLayout>
    <NuxtRouteAnnouncer />
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
// Load fonts and icons asynchronously without blocking render
const { public: publicConfig } = useRuntimeConfig();
const gtmId = publicConfig.GTM_ID as string;
useHead({
  script: gtmId
    ? [
        // Google Tag Manager
        {
          innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`,
        },
      ]
    : [],
  link: [
    // Preconnect to speed up external resources
    { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
    { rel: "dns-prefetch", href: "https://fonts.gstatic.com" },
    { rel: "dns-prefetch", href: "https://cdn.jsdelivr.net" },
    // Preload font CSS with low priority (loads after page renders)
    {
      rel: "preload",
      as: "style",
      href: "https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&display=swap",
      onload: "this.onload=null;this.rel='stylesheet'",
    },
    // Load flag icons with low priority
    {
      rel: "preload",
      as: "style",
      href: "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/css/flag-icons.min.css",
      onload: "this.onload=null;this.rel='stylesheet'",
    },
  ],
  noscript: [
    // GTM noscript fallback (body open)
    ...(gtmId
      ? [
          {
            innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
            tagPosition: "bodyOpen" as const,
          },
        ]
      : []),
    // Fallback for no-JS
    {
      innerHTML:
        '<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&display=swap">',
    },
    {
      innerHTML:
        '<link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/css/flag-icons.min.css">',
    },
  ],
});
</script>
